import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isEditPage, isRelistPage } from '../../helpers/router.helper';

@Component({
    selector: 'property-information-notice-with-display-fields',
    templateUrl: './property-information-notice-with-display-fields.component.html',
    styleUrls: ['./property-information-notice-with-display-fields.component.scss']
})
export class PropertyInformationNoticeWithDisplayFieldsComponent implements OnInit {

    @Input() displayFields: string;

    noticeMessage: string;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        if (isEditPage(this.route)) {
            this.noticeMessage = `It is not possible to change ${this.displayFields} 
            once the property has been live on site for 7 days.`;
        } else if (isRelistPage(this.route)) {
            this.noticeMessage = `It is not possible to change ${this.displayFields} when relisting a property.`;
        }
    }
}
